import { GuestUserConsumer } from '@chr/navisphereonline-shared-components';
import { Redirect } from 'react-router-dom';
import { hasUserProfile } from '../../utilities/hasUserProfile';

export interface GuestUserRedirectProps {
}

const GuestUserRedirect = (props: GuestUserRedirectProps) => {
    return (
      <GuestUserConsumer>
        {isGuest => {
          if (!isGuest && hasUserProfile()) {
            return <Redirect push to="/pay-invoices" />
          }     
          else {
            return <Redirect to="/" />
          }
        }}
      </GuestUserConsumer>
    );
}

export default GuestUserRedirect;
